/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AddUserBody,
  CreateUserGroupBody,
  DeleteUserBody,
  TableModel1UserGet,
  UpdateUserGroupBody,
  UserGroupGet,
  UserGroupsFilter,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class UserGroups<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags UserGroups
   * @name UserGroupsDetail
   * @summary Получить группу пользователей по идентификатору
   * @request GET:/userGroups/{id}
   * @secure
   * @response `200` `UserGroupGet` Группа пользователей
   */
  userGroupsDetail = (id: string, params: RequestParams = {}) =>
    this.request<UserGroupGet, any>({
      path: `/userGroups/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags UserGroups
   * @name GetUserGroupList
   * @summary Получить список групп пользователей
   * @request POST:/userGroups/list
   * @secure
   * @response `200` `(UserGroupGet)[]` Список групп пользователей
   */
  getUserGroupList = (data: UserGroupsFilter, params: RequestParams = {}) =>
    this.request<UserGroupGet[], any>({
      path: `/userGroups/list`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags UserGroups
   * @name CreateUserGroup
   * @summary Создание группы пользователей
   * @request POST:/userGroups/create
   * @secure
   * @response `200` `void` Success
   */
  createUserGroup = (data: CreateUserGroupBody, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/userGroups/create`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags UserGroups
   * @name UpdateUserGroup
   * @summary Обновление группы пользователей
   * @request POST:/userGroups/{id}/update
   * @secure
   * @response `200` `void` Success
   */
  updateUserGroup = (id: string, data: UpdateUserGroupBody, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/userGroups/${id}/update`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags UserGroups
   * @name DeleteUserGroup
   * @summary Удаление группы пользователей
   * @request POST:/userGroups/{id}/delete
   * @secure
   * @response `200` `void` Success
   */
  deleteUserGroup = (id: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/userGroups/${id}/delete`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags UserGroups
   * @name GetUserList
   * @summary Возвращает список пользователей в группе пользователей
   * @request POST:/userGroups/{id}/getUserList
   * @secure
   * @response `200` `TableModel1UserGet` Список пользователей
   */
  getUserList = (id: string, data: UserGroupsFilter, params: RequestParams = {}) =>
    this.request<TableModel1UserGet, any>({
      path: `/userGroups/${id}/getUserList`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags UserGroups
   * @name AddUser
   * @request POST:/userGroups/{id}/addUser
   * @secure
   * @response `200` `void` Success
   */
  addUser = (id: string, data: AddUserBody, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/userGroups/${id}/addUser`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags UserGroups
   * @name DeleteUser
   * @summary Удаляет пользователя из группы пользователей
   * @request POST:/userGroups/{id}/deleteUser
   * @secure
   * @response `200` `void` Success
   */
  deleteUser = (id: string, data: DeleteUserBody, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/userGroups/${id}/deleteUser`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}
